"use client";

import { BRAND_LOGO_DARK_MARK_SRC } from "@/lib/brand-favicon";
import { useConvexAuth } from "convex/react";
import { useTranslations } from "next-intl";
import type { ReactElement } from "react";
import { useReloadOnAreaChange } from "./use-reload-on-area-change";
import { useVersionCheck } from "./use-version-check";

/** Quiet pill: area switch reloads anyway, so it only serves users who stay on one page. */
export function UpdateAvailableBanner(): ReactElement | null {
  const t = useTranslations("common.updateAvailableBanner");
  const { isAuthenticated, isLoading } = useConvexAuth();
  const hasConvexSession = isAuthenticated && !isLoading;
  const { updateAvailable } = useVersionCheck(hasConvexSession);
  const showPill = hasConvexSession && updateAvailable;
  useReloadOnAreaChange(showPill);

  if (!showPill) return null;

  return (
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="fixed right-4 bottom-[calc(5rem+env(safe-area-inset-bottom,0px))] z-[100] flex h-9 items-center gap-2 rounded-full border border-primary/10 bg-background pr-3.5 pl-2 shadow-lg transition-colors animate-in fade-in slide-in-from-bottom-2 duration-300 hover:bg-accent md:bottom-4"
    >
      <img
        src={BRAND_LOGO_DARK_MARK_SRC}
        alt=""
        width={20}
        height={20}
        className="h-5 w-5 shrink-0 object-contain"
      />
      <span className="whitespace-nowrap text-[12px] font-medium text-primary/90">
        {t("neueVersionVerfuegbar")}
      </span>
      <span className="hidden whitespace-nowrap text-[12px] text-primary/50 sm:inline">
        {t("klickenZumNeuladen")}
      </span>
    </button>
  );
}
